import { useRef } from "react";
import { useSelector } from "react-redux";

import { isSignedIn } from "seneca-common/features/user/state";
import { useRedirectOnCondition } from "seneca-common/utils/hooks/routing";

export default function useRedirectIfInitiallySignedIn(link: string) {
  const signedIn = useSelector(isSignedIn);
  const initiallySignedInRef = useRef(signedIn);
  const initiallySignedIn = initiallySignedInRef.current;
  useRedirectOnCondition(initiallySignedIn, link);
}
